import React, { useState } from 'react'
import parse, { HTMLReactParserOptions, domToReact } from 'html-react-parser'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/livbrite/resources/constants'
import { ContactForm } from 'app/livbrite/components/ContactForm'
import { Container } from './styled'

export const CommunityLinks = () => {
  const [openModal, setOpenModal] = useState(false)
  const staticBlockID = CMS_BLOCK.FOOTER_COMMUNITY
  const staticBlock = useCmsBlock({
    id: staticBlockID,
    isLazy: false
  })

  if (!staticBlock.content) return null

  const options: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      const { attribs, children } = domNode

      if (!attribs) {
        return
      }

      if (attribs.class === 'contact-trigger') {
        return <span onClick={() => setOpenModal(true)} className='contact_trigger'>{domToReact(children, options)}</span>
      }
    }
  }

  return (
    <>
      <Container>
        {staticBlock.content && (
          <div>
            {parse(staticBlock.content, options)}
          </div>
        )}
      </Container>
      <ContactForm showForm={openModal} type='community_contact' setShowForm={setOpenModal} />
    </>
  )
}
